import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { ApiCallStatus } from 'store/statesHelper';
import SlicesRenderer from 'modules/_shared/components/SlicesRenderer';
import PageLoading from 'modules/_shared/ui-components/PageLoading';
import getTeacherTraining from 'modules/TeacherTraining/actionCreators';
import { SliceTypes } from 'api-doc/types/learning-platform';
import { useParams } from 'react-router-dom';
import { UnknownSlice } from '../../utils/commonTypes';
import Styled from './styled';

const TEACHER_TRAINING_DEFAULT = 'cpd-teacher-training';

const Resource: FunctionComponent = () => {
  const { uid } = useParams<{ uid?: string }>();
  const { data, status } = useSelector<
    RootState,
    RootState['teacherTrainingPage']
  >((state) => state.teacherTrainingPage);

  const dispatch = useDispatch();

  useEffect(() => {
    uid
      ? dispatch(getTeacherTraining(uid))
      : dispatch(getTeacherTraining(TEACHER_TRAINING_DEFAULT));
  }, [dispatch, uid]);

  const hasSideContent = (slices: Array<UnknownSlice>) =>
    slices.find((slice) => slice.sliceType === SliceTypes.AsideContent);

  return (
    <>
      {status === ApiCallStatus.LOADING && <PageLoading />}
      {status === ApiCallStatus.SUCCESS &&
        (hasSideContent(data!.slices) ? (
          <Styled.ResourceContainer>
            <SlicesRenderer slices={data!.slices} />
          </Styled.ResourceContainer>
        ) : (
          <SlicesRenderer slices={data!.slices} />
        ))}
    </>
  );
};

export default Resource;
